import React from 'react';
import { Flow } from 'flow-react';
import { connect } from 'react-redux';
import { observer } from 'mobx-react';
import { injectIntl } from 'react-intl';
import { withRouter } from 'helpers/ModuleHelper';
import * as actions from 'store/actions';
import * as ConfigTypes from 'config/ConfigTypes';
import {  getMetaConfig }
    from "helpers/ConfigHelper";
import CheckBox from "components/CheckBox/CheckBox";
import Dropdown from 'components/UI/Dropdown/Dropdown';
import * as CartShare from "components/Cart/CartShare/CartShare";
import CartSelectItem from 'components/Cart/CartRequest/CartSelectItem/CartSelectItem';
import {showFeCartMsg } from "helpers/CartHelper";
import './CartSelectList.scss'


const CartSelectList = observer(
    class CartRequest extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                data: [],
                itemslist: [],
                userInputs: {},
                changeObj: {},
                isChanging: false
            }
        }

        fm = ({ id }) => {
            if (id) return this.props.intl.formatMessage({ id });
            return null;
        };

        showSubHeadline = () => {
            return ConfigTypes.CARTREQUEST_SUBHEADLINEDATA.map(el => {
                if(el.type === ConfigTypes.BREAKLINE) return (<div className="cartselectlist-line"></div>)
                return (
                    <div className={el.htmlClasses ? el.htmlClasses : ''}>
                        {this.fm({ id: el.intl })}
                    </div>
                )
            })
        }

        setUserInputs = ({ showFields, isBtnClk = null }) => {
            let userInputs = { ...this.state.userInputs };
            let changeObj = {};
            if (showFields && showFields.length) {
                showFields.forEach(fi => {
                    if (fi.children && fi.children.length) {
                        fi.children.forEach(child => {
                            if (isBtnClk) changeObj[child.field] = !this.state.isChanging;
                            if (!this.state.userInputs[child.field]) {
                                userInputs[child.field] = this.props.user.metadata.fields[[child.field]] || '';
                            }
                        });
                    }
                    else {
                        if (isBtnClk) changeObj[fi.field] = !this.state.isChanging;
                        if (!this.state.userInputs[fi.field]) {
                            userInputs[fi.field] = this.props.user.metadata.fields[[fi.field]] || '';
                        }
                    }
                });
            }

            if (isBtnClk) this.setState({ isChanging: !this.state.isChanging, changeObj, userInputs });
            else this.setState({ userInputs });
        }


        showSingleItem = ({ item, idx }) => {
            let showFields = getMetaConfig({
                viewMode: ConfigTypes.CARTREQUEST_LIST, props: this.props,
                configName: ConfigTypes.ITEM
            });
            showFields = [...showFields, ...ConfigTypes.CARTREQUEST_ADDDATA];
            if (item && showFields && showFields.length) {
                return showFields.map((el, i) => {
                    let fieldTxt = CartShare.getFieldTxt({ item, el, i, idx });
                    if(el.type === ConfigTypes.INDEX) return null;
                    return (
                        <div key={`showItem_${Date.now()}_${i}`} className="cartselectlist-itemslist-li-group">
                            <label>{this.fm({ id: el.intl })}</label>
                            <div className={`${el.htmlClasses ? el.htmlClasses : ''}`}>{fieldTxt}</div>
                        </div>
                    )
                })
            }
            return null;
        }

      
        handleCbChange = ({ e, el }) => {
            this.setState({ userInputs: { ...this.state.userInputs, [el.field]: e.target.checked } });
        }

        onDDClick = ({ ddEl, el }) => {
            let ddVal = false;
            if (ddEl.name === el.name) ddVal = true;
            this.setState({ userInputs: { ...this.state.userInputs, [el.field]: ddVal } });
        }

        showAdvanced = ({data}) => {
            return data.map(el => {
                if (el.show) {
                    if (el.type === ConfigTypes.CHECKBOX) {
                        return <CheckBox onCbChange={(e) => this.handleCbChange({ e, el })}
                            isChecked={this.state.userInputs[el.name]}
                            label={this.fm({ id: el.intl })} />
                    }
                    if (el.type === ConfigTypes.DROPDOWN) {
                        return (
                            <div className="cartselectlist-dd-box">
                                <label>{this.fm({ id: el.intl })}</label>
                                <Dropdown
                                    data={el.data} current={this.state.userInputs[el.name]}
                                    onDDClick={(ddEl) => this.onDDClick({ ddEl, el })} />
                            </div>
                        )
                    }
                }
                return null;
            })
        }

     
        showPricePart = ({item, idx}) => {
             let viewMode = ConfigTypes.CARTREQUEST_PRICES;
            let showFields = getMetaConfig({
                viewMode, props: this.props,
                configName: ConfigTypes.ITEM
            });
            return showFields.map((el,i) => {
                 if(el.type == ConfigTypes.COMPLEX ){
                    return CartShare.showComplexElement({ el, idx, obj: item, viewMode, fm: this.fm});
                 }
                 let fieldTxt = CartShare.getFieldTxt({ item, el, i, idx });
                 return (
                    <div className="cartselectlist-complex">
                        <label className={el.htmlClasses ? el.htmlClasses : null}>
                            {this.fm({ id: el.intl })}
                        </label>
                        <p>{fieldTxt}</p>
                    </div>
                )
            })
        }

        showTotalPart = ({data, viewMode = ConfigTypes.CARTREQUEST_TOTAL}) => {
             const { cartData } = this.props.cartObjects;
            return data.map((el,idx) => {
                 if(el.type == ConfigTypes.COMPLEX ){
                    return CartShare.showComplexElement({ el, idx, obj: cartData, viewMode, fm: this.fm});
                 }
                 return (
                    <div className="cartselectlist-complex">
                        <label className={el.htmlClasses ? el.htmlClasses : null}>
                            {this.fm({ id: el.intl })}
                        </label>
                        <p></p>
                    </div>
                )
            })
        }

        showSources = () => {
            return ConfigTypes.CARTREQUEST_SOURCES.map(el => {
                if(el.isShow) return (
                    <div>{this.fm({id: el.intl})}</div>
                )
            })
        }

        showTotalRow = () => {
           return(
                <div className="cartselectlist-grid">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div>{this.showTotalPart({data: ConfigTypes.CARTREQUEST_TOTALDATA})}</div>
                    <div></div>
                </div>
           )
        }

         onDateAction = async ({ item, dates }) => {
            const { itemsCartList, itemsDateObj } = this.props.cartObjects;
            let newDates = dates.map(date => {
                let newDate = date.setTime(date.getTime() + ConfigTypes.ADD_TWO_HOURS);
                newDate = new Date(newDate).toISOString().split('T')[0];
                return newDate;
            });
            const newItems = itemsCartList.map(el => {
                if (el.id === item.id)  el.showdates = newDates;
                return el;
            });

            console.log("LOGS: onDateAction CartList item newDates", item, newDates);
            const res = await window.flow.sdkFeReAddToCart(item.id, newDates);
            console.log("LOGS: LAMTEST addToFeCart res", res);
            if (res && res.success) {
                this.props.updateCartObjects({
                    itemsCartList: newItems,
                    itemsDateObj: { ...itemsDateObj, [item.id]: newDates }
                });
            }
            showFeCartMsg({ msg: res.msg, fm: this.fm, props: this.props });
        }

         onOtherActions = ({ item, action }) => {
            const { itemsCartList } = this.props.cartObjects;
            let newItemsCart = [...itemsCartList];
            if (action && action === ConfigTypes.DELETE) {
                newItemsCart = itemsCartList.filter(li => li.id !== item.id);
                newItemsCart = newItemsCart.map((item,idx) => ({...item, position: idx + 1}))
                if (item.rentelid) this.props.removeFromFeCart({ rentelid: item.rentelid });
            }
            this.props.updateCartObjects({ itemsCartList: newItemsCart });
        }

        showListInCart = () => {
            const { itemsCartList } = this.props.cartObjects;
            return (
                <div className="cartselectlist-itemslist">
                      <div className="cartselectlist-sources">{this.showSources()}</div>
                    {itemsCartList && itemsCartList.map((item, idx) => {
                        return ( 
                        <CartSelectItem showSingleItem={this.showSingleItem} idx={item.position}
                            onDelete={()=>this.onOtherActions({item, action:ConfigTypes.DELETE })}
                            item={item} showPricePart={this.showPricePart} 
                            formatMessage={this.props.intl.formatMessage} cartObjects={this.props.cartObjects}
                            updateCartObjects={this.props.updateCartObjects} onDateAction={this.onDateAction}
                        /> 
                        )
                    })}
                    <div> {this.showTotalRow()}</div>
                </div>
            )
        }

        componentDidMount() {}

        render() {
            return (
                <div className="cartselectlist">
                    {this.showListInCart()}  
                </div>)
        }
    }
)

const mapStateToProps = (state) => ({
    mediaObjects: state.media.mediaObjects,
    cartObjects: state.cart.cartObjects,
    configObjects: state.config.configObjects,
    user: state.auth.authObjects.user,
});

const mapDispatchToProps = (dispatch) => ({
    updateAuthObjects: (obj) => dispatch(actions.updateAuthObjects(obj)),
    updateCartObjects: (obj) => dispatch(actions.updateCartObjects(obj)),
    updateMediaObjects: (obj) => dispatch(actions.updateMediaObjects(obj)),
    removeFromFeCart: (obj) => dispatch(actions.removeFromFeCart(obj)),
});

export default Flow.injectFlow(connect(mapStateToProps, mapDispatchToProps)(withRouter(injectIntl(CartSelectList))));


